import { computed, Ref } from "vue";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";
import router from "@/router";
// eslint-disable-next-line import/no-unresolved, import/extensions
import { NewsItemDetail } from "../../CdkNewsItem/types";
import i18n from "@/i18n";

export default (newsItemDetail: Ref<NewsItemDetail>) => {
  const mailToContent = computed(() => {
    const detailObject = newsItemDetail.value;
    if (!detailObject) {
      return "";
    }

    const title = detailObject.headline[0];
    const subject = `dpa-Select: ${title}`;
    const url = `${window.location.origin}/app/newsitems/${router.currentRoute.params.viewMode}/${detailObject.guid}`;

    let previewContent = "";
    if (typeof (detailObject.body as any) === "string") {
      previewContent = detailObject.body;
    } else if (detailObject.description.length) {
      previewContent =
        detailObject.description.find(({ role }) =>
          (role as String).match(/\/caption-extended|\/caption/)
        ).text || "";
    }

    const previewSentences = previewContent.split(/[.,!,?]\s/);
    const fourthSentence =
      previewSentences[Math.min(3, previewSentences.length - 1)];
    const thirdSentenceIndex = previewContent.indexOf(fourthSentence) - 1;
    const bodyPreview =
      previewSentences.length < 4
        ? previewContent
        : previewContent.slice(0, thirdSentenceIndex);
    const body = encodeURI(
      `${i18n.t("shareMailText.part1")} "${detailObject.headline[0]}" ${i18n.t(
        "shareMailText.part2"
      )} ${url}\n\n${title}\n\n${bodyPreview}${
        previewSentences.length > 3 ? " ... " : ""
      }`
    );
    return `mailto:%20?subject=${subject}&body=${body}`;
  });

  const shareViaEmail = () => {
    useMatomoEvent({
      category: `${getCurrentView()} View`,
      action: `Click "Via E-Mail teilen" in ${getCurrentView()} View`,
      name: `${getCurrentView()} View "Via E-Mail teilen"`
    });
    window.location.href = mailToContent.value;
  };

  return { mailToContent, shareViaEmail };
};
